import React, { useState, useEffect } from "react";
import CustomerProductList from "../ProductList/CustomerProductList";
import CustomerSubscriptionDashboard from "../Subscription/CustomerSubscriptionDashboard";
import ScrollingBanner from "../ScrollingBanner/ScrollingBanner";
import CustomerCreditsDisplay from "../BottleReturns/CustomerCreditsDisplay";
import TrialNotificationBanner from "../TrialNotificationBanner/TrialNotificationBanner";
import "./CustomerContainer.scss";

const CustomerContainer = (props) => {
  const [activeTab, setActiveTab] = useState('products');

  useEffect(() => {
    const handleSetTab = (event) => {
      setActiveTab(event.detail);
    };
    window.addEventListener('setCustomerTab', handleSetTab);
    return () => window.removeEventListener('setCustomerTab', handleSetTab);
  }, []);

  return (
    <div className="customer-container">
      <TrialNotificationBanner />
      <div className="customer-navigation">
        <button 
          className={activeTab === 'products' ? 'active' : ''}
          onClick={() => setActiveTab('products')}
        >
          Products
        </button>
        <button 
          className={activeTab === 'subscriptions' ? 'active' : ''}
          onClick={() => setActiveTab('subscriptions')}
        >
          My Subscriptions
        </button>
        <button 
          className={activeTab === 'credits' ? 'active' : ''}
          onClick={() => setActiveTab('credits')}
        >
          My Credits
        </button>
      </div>
      
      <div className="customer-content">
        {activeTab === 'products' && <CustomerProductList />}
        {activeTab === 'subscriptions' && <CustomerSubscriptionDashboard />}
        {activeTab === 'credits' && <CustomerCreditsDisplay />}
      </div>
    </div>
  );
};

export default CustomerContainer;